import { Component, Input, OnChanges, SimpleChanges, EventEmitter, Output, ViewChild } from '@angular/core';

import { PreviewPictureComponent } from '../previewProfilePicture/preview-profile-picture.component';
import { ProfilePictureService } from '../../../services/profile-picture.service';
import { ResourceService } from '../../../services/resource.service';
import { Configuration } from '../../../../shared/configurations/shared.config';
import { FileUploader } from '../../../components/fileUpload/classes/file-uploader.class';
import { FileSelectDirective } from '../../../components/fileUpload/directives/file-select.directive';

@Component({
    moduleId: module.id,
    providers: [ProfilePictureService, FileSelectDirective],
    selector: 'upload-profile-picture',
    templateUrl: 'upload-profile-picture.component.html',
    styleUrls: ['upload-profile.component.scss']
})

export class UploadPictureComponent {

    @Input("pictureId") pictureId: number;

    @Output() pictureIdChange: EventEmitter<number> = new EventEmitter<number>();

    @Input("imageClass") imageClass: string;

    @Input("uploadClass") uploadClass: string;

    @Input("required") required: boolean = false;

    showValidation: boolean = false;

    @Input() type: string = Configuration.type;

    @Input() allowedTypes: string = Configuration.allowedTypes;

    @Input() maxFileSize: number = Configuration.maxFileSize;

    @Input() maxFileNameLength: number = Configuration.maxFileNameLength;

    @Input("url") url: string = Configuration.urls.webApiEndpoint + Configuration.urls.attachmentUrl;

    @Output() onFileUploaded: EventEmitter<number> = new EventEmitter<number>();

    @ViewChild("previewprofilepicture") previewProfilePicture: PreviewPictureComponent;

    @ViewChild("fileselected") fileSelected: any;

    @Input() defaultUrl: string = "/assets/img/default-img.png";


    failedToUpload: boolean = false;

    messagesQueue: string[] = [];

    public uploader: FileUploader;

    constructor(private _profilePictureService: ProfilePictureService, private _resourceService: ResourceService) {

    }

    ngOnInit() {

        this.uploader = new FileUploader(
            {
                url: this.url,
                headers: [{ name: 'attach-type', value: this.type }],
                allowedFileType: this.allowedTypes,
                maxFileSize: this.maxFileSize,
                maxFileNameLength: this.maxFileNameLength
            });

        //File Upload Completed
        this.uploader.fileUploadCompleted.subscribe(metadata => {

            if (metadata && metadata.response) {

                var response = JSON.parse(metadata.response);

                var index = this.uploader.queue.findIndex(x => x == metadata.item);

                if (index >= 0) {

                    this.uploader.queue[index].isSuccess = !response.IsErrorState;
                    this.uploader.queue[index].isError = response.IsErrorState;

                    if (!response.IsErrorState) {
                        // set picture id 
                        this.pictureIdChange.emit(response.Value.Id);

                        this.uploader.queue[index].attachmentId = response.Value.Id;
                        this.uploader.queue[index].url = response.Value.Url;
                        this.uploader.queue[index].metadata = response;
                        this.onFileUploaded.emit(this.uploader.queue[index].attachmentId);
                    }
                }
            }

            this.failedToUpload = false;
            this.messagesQueue = [];
        });

        this.uploader.fileAdded.subscribe(file => {
            this.failedToUpload = false;
            this.messagesQueue = [];
        });

        //Filed Failed To Upload
        this.uploader.fileFailedToUpload.subscribe(metadata => {

            // clear message 
            this.messagesQueue = [];

            if (metadata) {

                if (metadata.filter.name == "fileType") {

                    this.messagesQueue.push(metadata.item.name + this._resourceService.Localize("shared", "PP_ProfilePicture_AllowedTypeMessage") + this.allowedTypes.replace(/,/g, ", "));

                }
                else if (metadata.filter.name == "fileSize") {

                    if (this.maxFileSize / 1024 / 1024 < 1) {
                        this.messagesQueue.push(metadata.item.name + this._resourceService.Localize("shared", "PP_ProfilePicture_MaxFileSize") + this.maxFileSize / 1024 + this._resourceService.Localize("shared", "PP_ProfilePicture_KB"));
                    }
                    else {
                        this.messagesQueue.push(metadata.item.name + this._resourceService.Localize("shared", "PP_ProfilePicture_MaxFileSize") + this.maxFileSize / 1024 / 1024 + this._resourceService.Localize("shared", "PP_ProfilePicture_MB"));
                    }
                }
                else if (metadata.filter.name == "fileName") {
                    this.messagesQueue.push(metadata.item.name + this._resourceService.Localize("shared", "PP_ProfilePicture_FileName") + this.maxFileNameLength + this._resourceService.Localize("shared", "PP_ProfilePicture_Characters"));

                }
                else if (metadata.filter.name == "fileDuplicate") {
                    this.messagesQueue.push(metadata.item.name + this._resourceService.Localize("shared", "PP_ProfilePicture_FileExist"));

                }

                this.showMessageQueue();
            }
        })

    }

    showMessageQueue() {
        this.failedToUpload = true;
    }

    // add or edit pic by delete old & add new
    async  editAddPicture() {

        if (this.uploader.getNotUploadedItems().length) {
            if (this.pictureId) {
                // delete file First
                await this._profilePictureService.deletePictureById(this.pictureId).then(result => {

                    //if result is not in error state and result has a value
                    if (result && result.ok) {

                        //// clear it to upload it second time
                        //this.uploader.queue.splice(this.uploader.queue.find(o => o.attachmentId == this.pictureId), 1);

                        // then add new file 
                        this.uploader.uploadAll();
                    }
                });
            }
            else
                // then add new file 
                this.uploader.uploadAll();
        }

    }

    async deletePicture() {

        if (this.pictureId) {
            // delete file First
            await this._profilePictureService.deletePictureById(this.pictureId).then(result => {

                //if result is not in error state and result has a value
                if (result && result.ok) {

                    // Clear form 
                    this.clearControl();

                    this.pictureIdChange.emit(this.pictureId);
                }
            });
        }
    }

    // if you forget to and u make browse only

    validate(): boolean {

        if (this.uploader.queue.length == 0) {
            return true;
        }

        for (var item of this.uploader.queue) {

            if (!item.isSuccess) {


                //Error Message
                var msg: string = this._resourceService.Localize("shared", "PP_ProfilePicture_UploadFileMessage");


                //if it displayed before
                var index = this.messagesQueue.findIndex(x => x == msg);

                //if not exist, push to queue
                if (index < 0) {
                    this.messagesQueue.push(msg);
                    this.showMessageQueue();
                }

                return false;
            }
        }

        return true;
    }

    requiredPicture(): boolean {


        // show message to file required
        if (this.required) {
            if (this.uploader && this.uploader.queue && this.uploader.queue.length > 0)
                return true;
            else {
                this.showValidation = true;
                return false;
            }
        }
        else
            return true;
    }

    clearControl(): void {
        this.messagesQueue = [];
        this.previewProfilePicture.removePicture();
        this.uploader.clearQueue();
        this.pictureId = undefined;
        if (this.fileSelected)
            this.fileSelected.nativeElement.value = '';
    }

}




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/profilePicture/uploadProfilePicture/upload-profile-picture.component.ts